module.exports = __webpack_public_path__ + "media/images/ms-e0dc12c94d4cf43d422e4e23e6179780.png";